export const IFRAME_REGEX = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))$/;
export const IFRAME_SOURCE_REGEX = /src="(.+?)"/;
